import React, { useContext, useState } from "react";

//images
import Logo from "../img/logo.png";
//Icons
import { SlBag } from "react-icons/sl";
import { FiMenu } from "react-icons/fi";
//Links
import { Link } from "react-router-dom";
//components
import SearchForm from "../components/SearchForm";
import CategoryNavMobile from "../components/CategoryNavMobile";
import Cart from "../components/Cart";
import { CartContext } from "../context/CartContext";
const Header = () => {
  const { IsOpen, setIsOpen,itemsAmount } = useContext(CartContext);
  const [catNavMobile, setCatNavMobile] = useState(false);
  return (
    <header className="bg-primary py-6 fixed w-full top-0 z-40 lg:relative xl:mb-[30px]">
      <div className="container mx-auto">
        <div className="flex flex-row gap-4 lg:items-center justify-between mb-4 xl:mb-0">
          {/* Menu */}
          <div
            onClick={() => setCatNavMobile(true)}
            className="text-3xl xl:hidden cursor-pointer"
          >
            <FiMenu />
          </div>
          {/* Category nav mobile */}
          <div
            className={` ${catNavMobile ? "left-0" : "-left-full"
              } fixed top-0 bottom-0 w-full h-screen z-30 transition-all duration-300`}
          >
            <CategoryNavMobile setCatNavMobile={setCatNavMobile} />
          </div>
          {/* logo */}
          <Link to={"/"}>
            <img src={Logo} alt="" className="w-[300px]" />
          </Link>
          {/* SearchForm - show on mobile only */}
          <div className="hidden w-full xl:flex xl:max-w-[734px]">
            <SearchForm />
          </div>
          {/* phone & cart */}
          <div className="flex items-center gap-x-[10px]">
            {/* phone */}
            <div className="hidden xl:flex uppercase">
              Need help? 123 456 789
            </div>
            {/* Cart icon */}
            <div
              onClick={() => setIsOpen(!IsOpen)}
              className="relative cursor-pointer"
            >
              <SlBag className="text-2xl" />
              <div className="bg-[#f24a04] text-primary absolute w-[18px] h-[18px] rounded-full top-3 -right-1 text-[13px] flex justify-center items-center font-bold tracking-[-0.1em]">
                {itemsAmount}
              </div>
            </div>
            {/* Cart */}
            <div
              className={`${IsOpen ? "right-0" : "-right-full"
                } bg-[#0e0f10] shadow-xl fixed top-0 bottom-0 w-full z-10 md:max-w-[500px] transition-all duration-300`}
            >
              <Cart />
            </div>
          </div>
        </div>

        {/* SearchForm - show on mobile only */}
        <div className="lg:hidden">
          <SearchForm />
        </div>
      </div>
    </header>
  );
};

export default Header;
